import { DialogContent, DialogTitle, Grid, IconButton } from "@mui/material";
import styled from "styled-components";

export const SGridContainer = styled(Grid)`
  && {
    padding: 24px;
    padding-top: 40px;
    padding-bottom: 0;
    border-radius: 8px;
  }
`;

export const SDialogTitle = styled(DialogTitle)`
  && {
    padding: 0;
  }
`;

export const SCloseButton = styled(IconButton)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    font-family: Montserrat, sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    height: 70px;
    color: rgb(51, 51, 51);
    border-radius: 4px;

    &:hover {
      border-radius: 4px;
    }
  }
`;

export const SDialogContent = styled(DialogContent)`
  && {
    display: flex;
    height: 80%;
    padding: 0;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(33, 33, 33, 0.2);
  }
`;

export const SGridColumn1 = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100%;
    border-radius: 8px;

    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.textDefault};
  }
`;
